import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { loadSlim } from "tsparticles-slim";
import { useCallback } from "react";
import Particles from "react-particles";

const HeroSection = () => {
  const { ref, inView } = useInView({ threshold: 0.1 });

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
  }, []);

  return (
    <motion.div
      className="HeroSection"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ type: "keyframes", duration: 1, bounce: 1, delay: 0.5 }}
    >
      <Particles
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
          background: {
            color: {
              value: "transparent",
            },
          },
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: {
                enable: true,
                mode: "push",
              },
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              push: {
                quantity: 15,
              },
              repulse: {
                distance: 200,
                duration: 3,
              },
            },
          },
          particles: {
            color: {
              value: "#9C27B0",
            },
            links: {
              color: "#E91E63",
              distance: 150,
              enable: true,
              opacity: 0.15,
              width: 1,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: {
                default: "bounce",
              },
              random: false,
              speed: 2,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 90,
            },
            opacity: {
              value: 0.15,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 5 },
            },
          },
          detectRetina: true,
          fullScreen: false,
        }}
      />
      <div className="info">
        <p className="highlight-2 small-heading fw-bold">Hi, I'm</p>
        <h1 className="fw-bold big-heading mt-2">Muhammad hasnain,</h1>
        <h1 className="fw-bold big-heading">
          I am a <span className=" grad-text">MERN Stack Developer.</span>
        </h1>
        <p className="text mt-2">
          A passionate MERN stack developer with a strong focus on building
          efficient and scalable web applications.
        </p>
        <a href="https://wa.me/03445059989" target={"_blank"}>
          <button className="px-4 py-2 animated-btn">Let's Talk</button>
        </a>
      </div>
    </motion.div>
  );
};

export default HeroSection;
